import controller from './sliders-t1.controller';
import template from './sliders-t1.view.html';

let SlidersT1Component = {
  template,
  controller,
  bindings : {
    cbItems : '<',
    cbName : '<'
  }
};

export default SlidersT1Component;



/** WEBPACK FOOTER **
 ** C:/Bitnami/wampstack-7.1.31-0/apache2/htdocs/toning/B2C/www/components/home/sliders/sliders-t1/sliders-t1.component.js
 **/